'use client'


import GlobalTopGame from "@/components_mobile/side_board/global_top_game"
import SportsAnalysisRanding from "@/components_mobile/side_board/sports_analysis"
import NewsList from "@/components_mobile/side_board/sports_news"
import SportsTeamGame from "@/components_mobile/side_board/sports_team_rank"
import TotoList from "@/components_mobile/side_board/toto"
import { useContext, useEffect, useState } from "react"
import SideHeader from "../header/side_header"
import { BannerContext } from "@/context/bannerContext"
import LiveSportsComponent from "@/app/livesports/liveSports";
import LiveScoreComponent from "@/app/livescore/liveScore";
import TopBanner from "@/components/etc/top_banner"
import SectionTitle from "@/components/etc/section_title"

export default function LeftSide() {
    const { main_top_banner } = useContext(BannerContext)
    
    const [showSpots, setshowSpots] = useState<boolean>(true);
    const [showScore, setshowScore] = useState<boolean>(false);
    
    return (
        <aside className="left-side">
            <TopBanner bannerUrl={main_top_banner[0]} />
            
            {/* 스포츠분석 */}
            <SportsAnalysisRanding />
            
            {/* 스포츠뉴스 */}
            {/* <NewsList /> */}
            {/* <TotoList /> */}
            {/* <GlobalTopGame /> */}

            {/* 실시간 스포츠 팀 순위 */}
            <div>
                
                <div>
                    {showSpots && <LiveSportsComponent type={"small"} setshowSpots={setshowSpots} 
                            setshowScore={setshowScore} 
                            showSpots={showSpots} 
                            showScore={showScore}/>}
                    {showScore && <LiveScoreComponent type={"small"} setshowSpots={setshowSpots} 
                            setshowScore={setshowScore} 
                            showSpots={showSpots} 
                            showScore={showScore}/>}
                </div>
            </div>

            {/* <SportsTeamGame /> */}
        </aside>
    )
}